  $(document).ready(function () {
            $('#menuToggle').on('click', function () {
                $('#sideMenu').addClass('open');
                $('#overlay').fadeIn();
            });

            $('#overlay').on('click', function () {
                $('#sideMenu').removeClass('open');
                $(this).fadeOut();
            });

            $('.tabs > ul > li ').click(function () {
                $('.tabs > ul > li').removeClass('active');
                $(this).closest('li').addClass('active');
            });

        });